import posthog from 'posthog-js';

const apiKey = process.env.REACT_APP_POSTHOG_PROJECT_API_KEY || '';

// Only initialize PostHog if we have a valid API key
if (apiKey) {
  posthog.init(apiKey, {
    api_host: 'https://us.i.posthog.com',
  });
} else {
  console.warn(
    'PostHog API key not found. Analytics will be disabled in development.'
  );
}

export default posthog;
